import { render, staticRenderFns } from "./EstatusUsuario.vue?vue&type=template&id=0d2f7b19"
import script from "./EstatusUsuario.vue?vue&type=script&lang=js"
export * from "./EstatusUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports